import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserAgentService } from '@shared/services';
import { WindowRef } from '@spartacus/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceDispatchGuard implements CanActivate {
  private readonly IOS_URL: string;
  private readonly ANDROID_URL: string;

  constructor(
    private winref: WindowRef,
    private userAgentService: UserAgentService,
    protected router: Router,
  ) {
    this.IOS_URL = 'https://apps.apple.com/us/app/sdvor/id1638603903';
    this.ANDROID_URL = 'market://details?id=com.rosa.sdvor.app';
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.userAgentService.os$.pipe(
      map((mobileOs) => {
        if (this.winref.isBrowser() && this.winref.nativeWindow) {
          switch (mobileOs) {
            case 'iOS':
              this.winref.nativeWindow.location.href = this.IOS_URL;
              break;
            case 'AndroidOS':
              this.winref.nativeWindow.location.href = this.ANDROID_URL;
              break;
          }
        }

        return true;
      }),
    );
  }
}
